import { render, staticRenderFns } from "./KindsPage.vue?vue&type=template&id=062e5b70"
import script from "./KindsPage.vue?vue&type=script&lang=js"
export * from "./KindsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports